import { Helmet } from 'react-helmet-async';

export default function SEO({
  title = 'JARCon ApS - Mekatronik, Konstruktion & Automation',
  description = 'JARCon ApS er en Mekatronik ingeniør og konsulentvirksomhed, som tilbyder Konsulentydelser, konstruktion og problemløsning indenfor produktionsudstyr og produkter.',
  image = 'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/hero-automation-engineering.jpg',
  canonical,
  lang = 'da'
}) {
  const fullTitle = title.includes('JARCon') ? title : `${title} - JARCon ApS`;

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      {image && <meta name="twitter:image" content={image} />}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}
